import React from "react";
import styled from "styled-components";
import { deviceSize } from "../../components/responsive";
import Account from "../../images/account/AccountingIcon.png";
import Bricks from "../../images/account/FinancialIcon.png";
import Bank from "../../images/account/RegulatoryIcon.png";

//MiddleSectionContainer
const MsC = styled.div`
  width: 100%;
  height: 700px;
  background: linear-gradient(to bottom, #fcfcfb 2%, #ffffff 30%);

  @media screen and (max-width: 768px) {
    height: 800px;
    margin-bottom: 0;
    padding-left: 10%;
    height: 840px;
  }
`;

const ContextContianer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding-top: 5%;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    flex-direction: column;
    height: 100%;
  }
`;

const QtHt = styled.h3`

	font-family: 'Roboto';
	font-style: bold;
	font-weight: 400;
	font-size: 28px;
	line-height: 33px;
	margin-bottom:60px;
	text-align:left;
	width: 60%;
	color: #499C99;
	margin-left: 10%;


@media screen and (max-width: ${deviceSize.slaptop}px) {
	margin-right:3%;
	width:95%;
 
  }


@media screen and (max-width:${deviceSize.tablet}px){
	
	width:100%;
	padding-left:2%;

}




@media screen and (max-width:${deviceSize.mobile}px) {

      font-size:13px;
      width:95%;
      margin-left:0;
      margin-bottom: 5%;
      padding-left: 0;
  	}

  

 `;

//PerksWrap
const Pw = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 75%;
  margin-left: 10%;
  height: 500px;
  flex-wrap: wrap;



  @media screen and (max-width: 768px) {
    font-size: 16px;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    text-align: left;
    margin-left: 0;
    height: 831px;
    width: 100%;
  }
`;

//PerksContianer
const Pc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 19%;
  height: 277px;
  margin-right: 5%;

  @media screen and (max-width: ${deviceSize.tablet}px) {
    margin-left: 5%;
    width: 40%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 16px;
    margin-left: 0;
    width: 95%;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    font-size: 16px;
    margin-left: 9px;
    width: 93%;
  }
`;

//PerksContianerImage
const PcI = styled.div`
  width: 60.86px;
  height: 49.94px;
  align-items: left;
  margin-bottom: 20px;
`;

//perks header one
const Ph = styled.h3`
  font-family: "Roboto", sans-serif;
  font-weight: 420;
  text-align: left;
  font-size: 18px;
  color: black;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
    width: 90%;
  }
`;


const Al = styled.div`
  width: 350px;
  height: 600px;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
    width: 99%;
    height: 500px;
  }
`;

const Pu = styled.ul`
  padding-left: 0;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    margin-left: 10px;
  }
`;

const Pl = styled.li`
  font-family: "Sunflower";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  text-align: left;
  list-style-type: disc;
  color: #454545;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.8em;
  }
`;

const Img = styled.img`
  width: 65px;
  height: 53px;
  padding-right: 0;
  align-items: left;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 32.19px;
    height: 30.94px;
  }
`;

export function MiddleSectionContactUs() {
  return (
    <MsC id="msc">
      <ContextContianer id="context-container">
        <QtHt>Discover the wealth of positions Exp can staff.</QtHt>
        <Pw>
          <Pc>
            <PcI>
              <Img src={Account} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Accounting</Ph>

            <Al>
              <Pu>
                <Pl>Controllers</Pl>
                <Pl>Accountants</Pl>
                <Pl>Senior Accountants</Pl>
              </Pu>
            </Al>
          </Pc>

          <Pc>
            <PcI>
              <Img src={Bricks} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Financial</Ph>

            <Al>
              <Pu>
                <Pl>CFOs</Pl>
                <Pl>Actuaries</Pl>
                <Pl>Financial Analysts</Pl>
              </Pu>
            </Al>
          </Pc>

          <Pc>
            <PcI>
              <Img src={Bank} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Regulatory & More</Ph>

            <Al>
              <Pu>
                <Pl>Auditors</Pl>
                <Pl>Compliance Officers</Pl>
                <Pl>Payroll,Onboarding,Etc.</Pl>
              </Pu>
            </Al>
          </Pc>
        </Pw>
      </ContextContianer>
    </MsC>
  );
}
